import * as _ from 'underscore';
import React from 'react';
import { connect } from 'react-redux';

import Button from 'material-ui/Button';
import ChatIcon from '@material-ui/icons/Chat';
import PlayIcon from '@material-ui/icons/PlayCircleFilled';

import BlockInstruction from './BlockInstruction';
import BlockLeaderboard from './BlockLeaderboard';
import Drop from '../Drop';
import MegaDrop from '../MegaDrop/MegaDrop';

import badgeStyle from '../../../../lib/customStyles/badgeStyle';
import * as DesignerState from '../../../../state/reducer/designer/designer';
import * as Utils from '../../../../lib/designerUtils';
import Console from '../../../../lib/debug';

export class BlockTextContentsClass extends React.Component {
    state = {
        selectedTags: [],
        toggle: this.props.newExercise
            ? true
            : this.props.block.instruction !== ''
    };

    componentDidUpdate() {
        let blockEditing = this.props.blockEditing;
        if (blockEditing) {
            this.search && this.search.focus();
        }
    }

    create() {
        let block = this.props.block;
        DesignerState.toggleCircuitDialog(block, true);
    }

    enableEditing() {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.enableEditing(dispatch, block);
    }

    async exerciseAdd(exercise) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        DesignerState.disableEditing(dispatch, block);
        if (exercise.id) {
            if (!block.id) {
                const blockId = await DesignerState.waitForBlockId(block.key);
                block = { ...block, id: blockId };
            }
            DesignerState.createSetExercise(block, exercise);
        }
    }

    filterByTags(_tags) {
        let allOptions = this.props.exerciseBenchmarkRef.options
            ? this.props.exerciseBenchmarkRef.options
            : this.props.exerciseBenchmarkRef;
        return Utils.filterOptionsByTags(allOptions, _tags);
    }

    filterUpdate(newValue) {
        let dispatch = this.props.dispatch;
        let block = this.props.block;
        DesignerState.updateBlockTags(dispatch, block, newValue);
        this.setState(() => ({
            selectedTags: newValue
        }));
    }

    getBlockTags(tags) {
        let newTags = [];
        if (tags) {
            newTags = tags.length ? tags.slice(0) : [];
            if (newTags.length > 3) {
                newTags.splice(3, newTags.length - 3);
            }
        }
        return newTags;
    }

    getFilteredExerciseRef() {
        let blockExercises = [];
        _.map(this.props.exercises, ex => {
            if (this.props.block.exerciseKeys.indexOf(ex.id) >= 0) {
                blockExercises.push(ex);
            }
        });
        let exerciseIds = _.pluck(blockExercises, 'exercise_id');
        let data = this.props.exerciseRef.filter(
            ex => exerciseIds.indexOf(ex.id) < 0
        );
        return data;
    }

    getOptions() {
        let block = this.props.block;
        if (!block.tags || (block.tags && block.tags.length === 0)) {
            return this.filterByTags(this.state.selectedTags);
        } else {
            return this.filterByTags(block.tags);
        }
    }

    onNewOptionClick(exercise) {
        let block = this.props.block;
        let newExercise = {
            title: exercise.title,
            eType: 'e',
            tags: [],
            exercises: []
        };
        DesignerState.toggleExerciseDialog(block, newExercise, true, true);
    }

    onToggle() {
        this.setState(() => ({
            toggle: !this.state.toggle
        }));
    }

    setBlockPlainText(plainTextExercise) {
        let block = this.props.block;
        let dispatch = this.props.dispatch;
        let tagRef = this.props.tagRef;
        let match = _.findWhere(this.props.exerciseBenchmarkRef.options, {
            id: plainTextExercise.id
        });

        if (match && !tagRef.length) {
            tagRef = this.getBlockTags(match.tags || []);
            this.setState(() => ({
                selectedTags: tagRef
            }));
        }
        DesignerState.setBlockPlainText(dispatch, block, plainTextExercise);
    }

    toggleCreateCircuit() {
        let block = this.props.block;
        DesignerState.toggleCircuitDialog(block, true, true);
    }

    render() {
        Console.render('designer.BlockTextContents');
        let dispatch = this.props.dispatch;
        let session = this.props.session;
        let block = this.props.block;
        let videos = this.props.elements;
        let exerciseBenchmarkRef = this.props.exerciseBenchmarkRef;
        let exerciseRef = this.getFilteredExerciseRef();
        let blockEditing = this.props.blockEditing;
        let tagRef = this.props.tagRef;

        let _badgeStyle = {
            ...badgeStyle,
            color: this.state.toggle ? '#fff' : '#1f242a'
        };

        let videosBadge = videos.length ? (
            <span
                style={{ ..._badgeStyle, fontSize: 11, lineHeight: 2.9 }}
                className="btn-badge"
            >
                {videos.length}
            </span>
        ) : null;

        let options = this.getOptions();
        let gridButton = null;

        let exerciseSearch = (
            <div className="exercise-select">
                <MegaDrop
                    value={block}
                    type="circuit"
                    placeholder={`${
                        !block.workout_combo_id
                            ? 'Untitled Circuit'
                            : 'Select Superset or Circuit'
                    }`}
                    auto={this.props.blockFocused}
                    options={options}
                    optionsRef={exerciseBenchmarkRef}
                    tags={tagRef}
                    selectedTags={this.state.selectedTags}
                    itemSelect={this.setBlockPlainText.bind(this)}
                    handleTags={this.filterUpdate.bind(this)}
                    createItem={this.create.bind(this)}
                    onTitleChange={this.props.onBlockTitleChange}
                    onChangeToEmptyCircuit={this.props.onChangeToEmptyCircuit}
                />
            </div>
        );

        let videoSearch = null;
        let videoButton = null;
        if (!blockEditing) {
            if (videos.length !== 0) {
                videoButton = (
                    <div className="exercise-chip layout-row">
                        <button
                            className="exercise-chip clean-button"
                            onClick={this.enableEditing.bind(this)}
                        >
                            <i className="mdi mdi-plus-circle" />
                            <span>Video</span>
                        </button>
                    </div>
                );
            } else {
                videoButton = (
                    <button
                        className="exercise-chip clean-button"
                        onClick={this.enableEditing.bind(this)}
                    >
                        <i className="mdi mdi-plus-circle" />
                        <span>Video</span>
                    </button>
                );
            }
        } else {
            options = exerciseRef.sort(function(a, b) {
                return a.title.toLowerCase() > b.title.toLowerCase() ? 1 : -1;
            });
            options = _.map(options, option => {
                return { id: option.id, title: option.title };
            });
            videoSearch = (
                <div className="exercise-search">
                    <Drop
                        ref={component => (this.search = component)}
                        placeholder="Select Video(s)"
                        options={options}
                        promptTextCreator={i => `Create exercise "${i}"`}
                        onNewOptionClick={this.onNewOptionClick.bind(this)}
                        clearable={false}
                        openOnFocus={true}
                        autofocus={true}
                        onChange={this.exerciseAdd.bind(this)}
                        labelKey="title"
                        valueKey="id"
                    />
                </div>
            );
        }

        let gridVideos = (
            <div className="grid-videos">
                {videos}
                {videoButton}
                {gridButton}
            </div>
        );
        let blockTitle = Utils.getBlockTitle(
            session.setKeys.indexOf(block.key)
        );
        let videoSearchClasses = `exercise${
            block.plain_text === 1 ? ' chips' : ''
        }`;

        let blockVideos = this.state.toggle ? (
            <div className="block-videos">
                <div className={videoSearchClasses}>{gridVideos}</div>
                {videoSearch}
            </div>
        ) : null;

        let blockInstruction = this.state.toggle ? (
            <BlockInstruction
                textareaRef={el => (this.$textArea = el)}
                block={block}
                disabled={block.workout_combo_id !== null}
                onNewCircuit={this.toggleCreateCircuit.bind(this)}
                dispatch={dispatch}
            />
        ) : null;

        let blockBodyClasses = 'block-body';

        return (
            <div className={`block-text${this.state.toggle ? ' opened' : ''}`}>
                <div className="exercise">
                    <div className="exercise-content">
                        <div className="exercise-search">
                            <span className="exercise-subtitle">
                                {blockTitle}
                            </span>
                            {exerciseSearch}
                        </div>
                        <div className="exercise-tables">
                            <div className="leaderboard-wrapper">
                                <BlockLeaderboard
                                    block={block}
                                    dispatch={dispatch}
                                />
                                <Button
                                    className={`MegaDrop-button ${
                                        this.state.toggle ? 'active' : ''
                                    }`}
                                    onClick={this.onToggle.bind(this)}
                                >
                                    <PlayIcon />
                                    {videosBadge}
                                </Button>

                                <Button
                                    className={`MegaDrop-button ${
                                        this.state.toggle ? 'active' : ''
                                    }`}
                                    onClick={this.onToggle.bind(this)}
                                >
                                    <ChatIcon />
                                </Button>
                            </div>
                        </div>
                    </div>
                    <div className={blockBodyClasses}>
                        {blockInstruction}
                        {blockVideos}
                    </div>
                </div>
            </div>
        );
    }
}

const mapBlockTextContentStateToProps = (state, ownProps) => {
    let isNewExercise =
        state.calendar.uiTree.newExercise &&
        state.calendar.blockTree[state.calendar.uiTree.newExercise];
    return {
        block: state.calendar.blockTree[ownProps.block.key],
        tagRef: state.calendar.uiTree.exerciseTags,
        blockEditing:
            state.calendar.uiTree.blockEditingKey === ownProps.block.key,
        blockFocused:
            state.calendar.uiTree.blockFocusedKey === ownProps.block.key,
        exerciseBenchmarkRef: state.library.exerciseBenchmarkRef,
        exerciseRef: state.library.exerciseRef,
        exercises: state.calendar.exerciseTree,
        newExercise: isNewExercise,
        ...ownProps
    };
};

export default connect(mapBlockTextContentStateToProps)(BlockTextContentsClass);



// WEBPACK FOOTER //
// ./src/view/designer/components/Block/BlockTextContents.jsx